// extracted by mini-css-extract-plugin
module.exports = {"link":"link__prKxX"};